import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-visionbook-finishedbook-adventure.jpg`;
const ALT = "Lara holding open a completed Vision Book spread filled with 'New Adventure,' 'Nurture' and 'Unstoppable' collage pages, against a bright architectural wall.";

export function ADifferentKindOfVisionBook() {
  return (
    <section data-testid="vbw-different-kind-section" className="relative overflow-hidden bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10 pt-[42px] md:pt-[57px] pb-[10px] md:pb-[16px] reveal">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
            A Different Kind of Vision Book
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[52px] leading-[1.1] tracking-tight text-[#1C1917] mb-3">
            This isn&rsquo;t something you make once.
          </h2>
          <p className="font-display text-xl md:text-2xl text-[#159E9A] italic leading-snug mb-8">
            It&rsquo;s something you return to.
          </p>
          <div className="space-y-[12.8px] text-[20px] md:text-[22px] leading-[1.23] text-[#57534E]">
            <p>Most vision boards are created once, hung on a wall and quietly forgotten.</p>
            <p>A Vision Book is different.</p>
            <p>It becomes a place to collect what matters through every season of your life.</p>
          </div>
        </div>
      </div>

      {/* Featured spread — one large image only, shown near its native
          aspect ratio to avoid a tight crop, per Page Lock. Lightly
          feathered into the surrounding whitespace, matching the site's
          established editorial image treatment. Sized up ~27% (max-w-5xl ->
          max-w-7xl, 944px -> 1200px displayed width at desktop) per request. */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-[36px] md:py-[47px] reveal">
        <div className="relative w-full aspect-[1318/1003]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="vbw-adventure-spread-image"
            bg="#FFFFFF"
            objectPosition="center"
            featherLeft={8}
            featherRight={8}
            featherTop={8}
            featherBottom={8}
            className="absolute inset-0"
          />
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-10 pb-[42px] md:pb-[57px] reveal">
        <div className="max-w-2xl">
          <div className="space-y-[12.8px] text-[20px] md:text-[22px] leading-[1.23] text-[#57534E]">
            <p>You might begin one after a divorce.</p>
            <p>Before retirement.</p>
            <p>When your children leave home.</p>
            <p>After losing someone you love.</p>
            <p>When a new dream refuses to leave you alone.</p>
            <p>Or simply because you&rsquo;ve realized it&rsquo;s time to stop living on autopilot.</p>
            <p>Some pages help you dream.</p>
            <p>Some help you heal.</p>
            <p>Some remind you who you&rsquo;ve always been.</p>
            <p>The book grows because you do.</p>
            <p>That&rsquo;s why many people create a new Vision Book every year.</p>
            <p>Others return to the same book for years, adding new pages as life unfolds.</p>
            <p>There isn&rsquo;t a right way.</p>
            <p className="text-[#1C1917]">Only your way.</p>
          </div>

          <div className="mt-9 space-y-1">
            <p className="font-display text-xl md:text-2xl text-[#57534E] italic leading-snug">
              Your Vision Book isn&rsquo;t the destination.
            </p>
            <p className="font-display text-xl md:text-2xl text-[#159E9A] italic leading-snug">
              It&rsquo;s a companion you&rsquo;ll return to whenever life asks a
              new question.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
